import './ListSidebarItem.scss'

import React from 'react'
import { Link } from 'react-router-dom'

const ListSidebarItem = ({ name, linkTo, isActive, IconComponent }) => (
  <li className="list-sidebar-item">
    <Link
      aria-current={isActive ? 'page' : false}
      to={linkTo}
      className={`list-sidebar-item__list-item is-${isActive ? 'active' : 'not-active'}`}
    >
      {IconComponent && <IconComponent className="list-sidebar-item__list-item-icon" />}
      <span className="list-sidebar-item__item-name">{name}</span>
    </Link>
  </li>
)

export default ListSidebarItem
